import Axios from "../util/axiosInstance";

export const CheckProjectTalentAccess = (projectId, status) => {
    return Axios.get(`/api/TalentJobCenter/CheckProjectTalentAccess?Projectid=${projectId}&status=${status}`);
};